import { formatName, formatPhone, formatEmail } from '../lib/format';
import FieldLabel from './ui/FieldLabel';
import Textarea from './ui/Textarea';
import UiInput from './ui/Input';
import React, { useEffect, useState } from "react";
const Input = ({ type, label, required, multiline, inputMode, placeholder, preventPaste, value, setValue, disabled, errors = [], name, errorMessage, step, deferCommit = false, onDraftChange }) => {
    const normalizedLabel = String(label || placeholder || '').trim().toLowerCase()
    const isPersonNameField = normalizedLabel === 'first name' || normalizedLabel === 'last name' || normalizedLabel === 'surname'
    const isCompanyNameField = normalizedLabel === 'company name'
    const shouldAutoCapitalize = isPersonNameField || isCompanyNameField
    const capitalizeFirstCharacter = (nextValue) => {
        const text = String(nextValue || '')
        return text ? text.charAt(0).toUpperCase() + text.slice(1) : text
    }
    const capitalizeEachWord = (nextValue) => String(nextValue || '').replace(/(^|\s)(\S)/g, (match) => match.toUpperCase())
    const formatValue = (nextValue) => isCompanyNameField
        ? capitalizeEachWord(nextValue)
        : (isPersonNameField ? capitalizeFirstCharacter(nextValue) : nextValue)
    const [draftValue, setDraftValue] = useState(value || '')
    useEffect(() => setDraftValue(value || ''), [value])
    const rawDisplay = deferCommit ? draftValue : (value || '')
    const displayedValue = isPersonNameField ? formatName(rawDisplay) : disabled ? /phone|contact number|mobile/.test(normalizedLabel) ? formatPhone(rawDisplay) : /email/.test(normalizedLabel) ? formatEmail(rawDisplay) : formatValue(rawDisplay) : formatValue(rawDisplay)
    const updateValue = (nextValue) => {
        const formattedValue = formatValue(nextValue)
        if (deferCommit) {
            setDraftValue(formattedValue)
            onDraftChange?.(formattedValue)
            return
        }
        setValue(formattedValue)
    }
    const commitDraft = () => {
        if (deferCommit && draftValue !== value) setValue(formatValue(draftValue))
    }

    return (<div>
        <FieldLabel className={label ? 'fieldLabel' : 'fieldLabel fieldLabelEmpty'}>{label || ''} {required && <span className="uiRequired" style={{ color: '#dc2626' }}>*</span>}</FieldLabel>
        {
            multiline ? <Textarea disabled={!!disabled} className={errors.includes(name) ? 'error' : ''} type={type} placeholder={placeholder || ''} value={displayedValue} onChange={(e) => updateValue(e.target.value)} onBlur={commitDraft} >

            </Textarea> :

                <UiInput aria-label={label || placeholder || undefined} autoCapitalize={shouldAutoCapitalize ? 'words' : undefined} inputMode={inputMode} step={step} onPaste={(e) => { preventPaste && e.preventDefault(); return false }} autoComplete="false" disabled={!!disabled} className={errors.includes(name) ? 'error' : ''} type={type} placeholder={placeholder || ''} value={displayedValue} onChange={(e) => updateValue(e.target.value)} onBlur={commitDraft} />
        }
        {errorMessage && <p className="uiFieldError" style={{ margin: 0 }}>{errorMessage}</p>}
    </div>)

}

export default Input
